<div class="overflow-hidden bg-col-w full-screen-hero-banner-component">
    <href [link]="component.link"
          [hrefClass]="'w-12 height-100'">
        <div class="w-12 height-100 pos-relative">
            <div class="fill overflow-hidden">
                <!-- image -->
                @if (component.image && component.variant === 'image') {
                <div class="media__wrapper media__wrapper--cover">
                    <div class="media-image">
                        <img class="media-image__image"
                             [alt]="component.title"
                             [dfImage]="component.image"
                             [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                             ratio="auto"
                             fill>
                    </div>
                </div>
                }
                @if (component.video_id && component.variant === 'video') {
                <local-vimeo-player class="fill"
                                    [video-id]="component.video_id"
                                    [autoplay-in-viewport]="component.video_autoplay"
                                    [autoplay-on-pause]="false"
                                    [background]="component.video_background"
                                    [controls]="false"
                                    [muted]="true">
                    <!-- play icon -->
                    <ng-template #playButton>
                        <button class="video-icon">
                            <i class="col-w icon-play"
                               aria-hidden="true"></i>
                        </button>
                    </ng-template>

                    <!-- pause icon -->
                    <ng-template #pauseButton>
                        <button class="video-icon">
                            <i class="col-w icon-pause"
                               aria-hidden="true"></i>
                        </button>
                    </ng-template>
                </local-vimeo-player>
                }
            </div>
            @if (component.title) {
            <div class="fill z-2 flex flex-middle flex-justify-center center pe-none">
                <!-- title -->
                <p [sizeClass]="'!S:hero,S:h1'"
                   [ngClass]="component.color || ''"
                   *iCms="'title' of component"></p>

                @if (component.content) {
                <div class="m-t-1 p2 text"
                     [ngClass]="component.color || ''"
                     *iCms="'content' of component"></div>
                }

                <!-- button -->
                @if (component.cta_text) {
                <div class="m-t">
                    <action class="pe-auto"
                            [ngClass]="component.cta_style">
                        <span *iCms="'cta_text' of component"></span>
                    </action>
                </div>
                }
            </div>
            }
        </div>
    </href>
</div>